import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=510ea11b&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=510ea11b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ea11b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510ea11b')) {
      api.createRecord('510ea11b', component.options)
    } else {
      api.reload('510ea11b', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=510ea11b&scoped=true&", function () {
      api.rerender('510ea11b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/MenuItem.vue"
export default component.exports